import filter from 'lodash/filter';
import upperCase from 'lodash/upperCase';
import cookies from 'react-cookies';
import COOKIES from '../config/cookies/cookies';
import { LINKS_GLOBAL_AWIN } from '../config/links/links';
import { getBasketQuantity } from './basket';
import WalletService from './walletService';

export const prepareTrackingData = ({
  basketProducts,
  order,
  orderSummary,
  paymentData,
  type,
}) => {
  const data = {
    cardType: type,
    currency: orderSummary.currency,
    productOrder: order.productOrder,
    quantity: getBasketQuantity(basketProducts),
    walletAmountUsed: paymentData.walletAmount,
  };

  return {
    config: { data: JSON.stringify(paymentData) },
    data,
  };
};

export const getWalletAmount = async (orderSummary) => {
  const response = await WalletService.getWallet();
  const userWallets = filter(response.data, (wallet) => {
    return wallet.currency === upperCase(orderSummary.currency);
  });

  return userWallets[0].balance;
};

export const getDeliveryOptionType = ({ product, orderSummary }) => {
  return product.deliveryOptionType && !orderSummary.postageOnRedemption
    ? Object.prototype.hasOwnProperty.call(
        product.deliveryOptionType,
        'deliveryOptionType',
      )
      ? product.deliveryOptionType.deliveryOptionType
      : product.deliveryOptionType
    : null;
};

export const getOrderLinesPayload = ({ deliveryOptionType, product }) => {
  return {
    dealVoucherProductId: product.payDeposit
      ? product.depositProduct.id
      : product.id,
    deliveryOptionType,
    gift: product.gift,
    gifting: product.gifting,
    giftPack: product.giftPack,
    giftWrap: product.giftWrap,
    orderAddons: product.orderAddons,
    quantity: product.quantity,
  };
};

export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const hasMarketingConsent = () => {
  const consentCookie = cookies.load(COOKIES.optConsent);

  if (!consentCookie) return false;

  const decoded = decodeURIComponent(consentCookie);
  const groupsMatch = decoded.match(/groups=([^&]+)/);

  if (!groupsMatch) return false;

  return groupsMatch[1].split(',').includes('C0004:1');
};

export const loadMarketingScript = () => {
  if (cookies.load(COOKIES.lightPage) === 'true') return;

  if (document.querySelector('awin-script')) return;

  const script = document.createElement('script');
  script.id = 'awin-script';
  script.src = LINKS_GLOBAL_AWIN;
  script.defer = true;
  document.body.appendChild(script);
};
